import { render, staticRenderFns } from "./DhmeWkbRisksDialog.vue?vue&type=template&id=b23bda08&scoped=true"
import script from "./DhmeWkbRisksDialog.vue?vue&type=script&lang=js"
export * from "./DhmeWkbRisksDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b23bda08",
  null
  
)

export default component.exports